import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { GeneralStore, GeneralState } from './general.store';

@Injectable({ providedIn: 'root' })
export class GeneralQuery extends Query<GeneralState> {

  selectIsMessageCount$ = this.select('messagesCount');
  selectIsmessagesIdToClose$ = this.select('messagesIdToClose');
  selectIsNotifications$ = this.select('notifications');

  constructor(protected store: GeneralStore) {
    super(store);
  }

  get messageCount(): number {
    return this.getValue().messagesCount;
  }

  get messagesIdToClose(): number {
    return this.getValue().messagesIdToClose;
  }

  get notificationCount(): number {
    return this.getValue().notifications.length;
  }

  get notifications(): Array<any> {
    return this.getValue().notifications;
  }

}
